import { Injectable } from '@angular/core';
import { duration } from 'moment/moment';
import { CacheService, IEntityCacheService } from '@nimbus-library/features/cache';

export interface ICompanionSplitScreenSession {
  conversationId: string | null;
  enabled: boolean;
  widthPct?: number;
}

const SESSION_KEY = 'companion-split-screen-session';

@Injectable({ providedIn: 'root' })
export class CompanionSplitScreenCacheService {
  private readonly sessionCache: IEntityCacheService<ICompanionSplitScreenSession>;

  public constructor(cacheService: CacheService) {
    this.sessionCache = cacheService.for<ICompanionSplitScreenSession>(SESSION_KEY, { cacheMaxAge: duration(1, 'day') });
  }

  public get(): ICompanionSplitScreenSession | null {
    const info = this.sessionCache.getInfo(SESSION_KEY);
    return info?.validForCache ? info.value : null;
  }

  public set(session: ICompanionSplitScreenSession): void {
    this.sessionCache.set(SESSION_KEY, session);
  }

  public clear(): void {
    this.sessionCache.remove(SESSION_KEY);
  }
}
